<template>
  <layout-default>
    <template v-slot:toolbar>
      
    </template>
    <div class="screeners">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <main-user-table
        :headers="headers"
        :items="screenerTemplates"
        :items-per-page="queryParams.pageSize"
        :server-items-length="pagination.totalCount || -1"
        :page="queryParams.page"
        :row-component="'screeners-table-row'"
        @to-screener="toScreener"
        @action:get-data="getDataAction"
      />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from "@/helpers/debounce"
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import MainUserTable from "@/components/tables/MainUserTable"
import RouterMixin from "@/mixins/router"

const defaultQueryParams = {
  isActive: true
}

export default {
  name: "Screeners",
  components: {
    LayoutDefault,
    MainUserTable
  },
  data () {
    return {
      headers: [
        { text: 'Title', value: 'title' },
        { text: 'Created', value: 'creationDate' }
      ],
      defaultQueryParams: { ...defaultQueryParams }
    }
  },
  mixins: [RouterMixin],
  computed: {
    ...mapState('screenersStates', [
      'screenerTemplates',
      'loading',
      'pagination'
    ]),
    isAdmin () {
      return this.dictionaryBhUsersRoleIds[this.getRolename] === this.dictionaryBhUsersRoleIds.Admin
    },
    ...mapState('dictionariesStates', [
      'dictionaryBhUsersRoleIds'
    ]),
    filteredQueryParams(){
      let obj = { ...this.defaultQueryParams, ...this.activeFilter }
      return Object.entries(obj).reduce((a,[k,v]) => (v == null ? a : (a[k]=v, a)), {});
    }
  },
  methods: {
    ...mapActions('screenersStates', [
      'getScreenerTemplates',
    ]),
    toScreener (id) {
      this.$router.push({ name: "Screener", path: "/screeners/:id", params: { id: id }});
    },
    getData (data) {
      debounce(() => {
        this.getScreenerTemplates(data)
      }, 100, 'getScreeners')
    },
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.screeners {
  padding: 2*$gutter;
}
</style>
